export const MAIN_CONTAINER =
    " max-w-7xl mx-2 xl:mx-auto  grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-x-2 md:gap-x-12 gap-y-9 md:gap-y-14 py-5 mt-2 md:mt-10  ";

export const CARD_CONTAINER_CLASS = "mx-auto lg:mx-2 max-w-[170px] md:max-w-sm";

export const LINE_IMAGE_CLASS = " mx-auto pb-2 pt-1";
